import { useCallback } from 'react';

import { getWindow } from '@change-corgi/core/window';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useSearchActions, useSearchResults, useSearchState } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<
	{
		currentPage: number;
		totalPages: number;
		shouldHidePagination: boolean;
	},
	{
		setPage: (selectedPage: number) => void;
	}
>;

export function usePaginationComponent(): Result {
	const state = useSearchState();
	const results = useSearchResults();
	const actions = useSearchActions();
	const track = useTracking();

	return {
		data: {
			currentPage: state.page,
			totalPages: results.nbPages,
			shouldHidePagination: results.nbHits === 0 && results.nbPages === 0,
		},
		actions: {
			setPage: useCallback(
				(selectedPage: number) => {
					void track('search', {
						context: 'pagination',
						q: state.query || '',
					});
					actions.setPage(selectedPage - 1);
					getWindow().scrollTo(0, 0);
				},
				[state.query, actions, track],
			),
		},
	};
}
